import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = '6LdvR-wrAAAAAN1NVytyq6RGzrVArnWldPQUxcZf';

const ReCaptchaWrapper = forwardRef((props, ref) =>
  <ReCAPTCHA
    sitekey={RECAPTCHA_SITE_KEY}
    ref={ref}
    hl='fr'
    size='invisible'
    onExpired={() => ref.current.reset()}
    {...props}
  />);

ReCaptchaWrapper.displayName = 'ReCaptchaWrapper';

export default ReCaptchaWrapper;
